import { UserAuth } from "../models/userAuth.model"
import { axiosLegoBricks } from "./axios.service";

export class UserService {

    public authenticate = async (userAuth: UserAuth) => {
        return await axiosLegoBricks().post('/User/Authenticate', userAuth);
    }
}